import { forwardRef } from 'react';

interface VenereInputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url';
  variant?: 'default' | 'error' | 'success';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  required?: boolean;
  className?: string;
  error?: string;
  helperText?: string;
}

export const VenereInput = forwardRef<HTMLInputElement, VenereInputProps>(({
  label,
  placeholder,
  value,
  onChange,
  type = 'text',
  variant = 'default',
  size = 'md',
  disabled = false,
  required = false,
  className = '',
  error,
  helperText,
}, ref) => {
  const baseClasses = 'w-full rounded-lg border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variantClasses = {
    default: 'venere-text-primary border-[var(--venere-slate)] focus:border-[var(--venere-royal)] focus:ring-[var(--venere-royal)] placeholder:text-[var(--venere-silver)]',
    error: 'border-[var(--venere-error)] focus:border-[var(--venere-error)] focus:ring-[var(--venere-error)] placeholder:text-[var(--venere-navy)]',
    success: 'border-[var(--venere-success)] focus:border-[var(--venere-success)] focus:ring-[var(--venere-success)] placeholder:text-[var(--venere-navy)]',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-3 text-base',
  };

  const inputVariant = error ? 'error' : variant;

  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label className="block venere-text-primary">
          {label}
          {required && <span className="text-[var(--venere-error)] ml-1">*</span>}
        </label>
      )}
      
      <input
        ref={ref}
        type={type}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`${baseClasses} ${variantClasses[inputVariant]} ${sizeClasses[size]}`}
      />
      
      {(error || helperText) && (
        <p className={`text-sm ${error ? 'text-[var(--venere-error)]' : 'text-[var(--venere-neutral-500)]'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

VenereInput.displayName = 'VenereInput';

export default VenereInput; 